import { productCategories } from '@/constants/flagAndCategory';
import { productStatusOptions } from '@/constants/status';

const headers = [
  { title: 'Kode', key: 'code', sortable: true },
  { title: 'Kategori', key: 'category', sortable: true },
  { title: 'Nama', key: 'name', sortable: true },
  { title: 'Deskripsi', key: 'description', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'Kode', key: 'code', type: 'text' },
  {
    title: 'Kategori',
    key: 'category',
    type: 'select',
    selectOptions: productCategories.map(({ value, title }) => ({ value, title })),
  },
  { title: 'Nama', key: 'name', type: 'text' },
  { title: 'Deskripsi', key: 'description', type: 'text' },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: productStatusOptions.map(({ value, title }) => ({ value, title })),
  },
];

export { filters, headers };
